import PropTypes from 'prop-types';
import React from 'react';
import Row from 'components/Row';
import Col from 'components/Col';
import moment from 'moment';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import Pagination from 'components/layout/pagination.jsx';

import {formatEmails} from './helpers';
import {FormattedMessage} from 'react-intl';
import {dateTimeFormats} from 'helpers/constants';

const SummaryField = ({label, value, ...props}) => {
  return <Col sm={3} className='result' {...props}>
    <label>{label}</label>
    <div>{value}</div>
  </Col>;
};

SummaryField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
};

const PastDueReportResults = ({summary, report, page, count, total, onPageChange, showNoDataMessage, activeFilters, formatMessage}) => {
  const {start, end} = activeFilters;

  if (!summary) {
    return <div className='summary-container'>
      <h2><FormattedMessage id="reports.report.summary" /></h2>
      <p><FormattedMessage id="reports.reveal.report.summary" /></p>
      {showNoDataMessage ?
        <label className='report-no-data'><FormattedMessage id="reports.error.no.results" /></label> :
        null}
    </div>;
  }

  return <Col sm={12} className='summary-container'>
    <Row>
      <h2>
        <FormattedMessage id="reports.report.summary" />
        <span className='summary-date'> | <FormattedMessage id="general.date.range.labelled" values={{
          start: start.format(dateTimeFormats.numeralDate),
          end: end.format(dateTimeFormats.numeralDate),
        }} />
        </span>
      </h2>
      <p className='description'><FormattedMessage id="reports.reveal.report.summary" /></p>
    </Row>
    <Row>
      <SummaryField label={formatMessage('general.total.accounts')} value={summary.totalAccounts} />
      <SummaryField label={formatMessage('general.total.systems')} value={summary.totalSystems} />
      <SummaryField label={formatMessage('general.total.pools')} value={summary.totalPools} />
      <SummaryField label={formatMessage('general.in.ground.pools')} value={summary.inGroundPools} />
      <SummaryField label={formatMessage('general.above.ground.pools')} value={summary.aboveGroundPools} />
      <SummaryField label={formatMessage('general.splasher.pools')} value={summary.splasherPools} />
      <SummaryField label={formatMessage('general.swim.spas')} value={summary.swimSpas} />
      <SummaryField label={formatMessage('general.spas')} value={summary.spas} />
      <SummaryField label={formatMessage('general.total.maintenance')} value={summary.systemsOnMaintenance} />
    </Row>
    {report && report.length > 0 ?
      <DetailedView report={report} page={page} count={count} total={total} onPageChange={onPageChange} formatMessage={formatMessage} /> :
      <div className='pad-top' />}
  </Col>;
};

const DetailedView = ({report, onPageChange, page, count, total, formatMessage}) => {
  return <div className='pad-top'>
    <table className='table-biolab table-striped past-due-table'>
      <thead style={{fontSize: '13px'}}>
        <tr>
          <th style={{width: '150px'}}><FormattedMessage id="general.primary.contact" /></th>
          <th><FormattedMessage id="general.primary.phone" /></th>
          <th style={{width: '130px'}}><FormattedMessage id="general.email.address" /></th>
          <th><FormattedMessage id="general.last.analysis" /></th>
          <th><FormattedMessage id="general.next.analysis" /></th>
          <th style={{width: '170px', paddingTop: '10px'}}>
            <FormattedMessage id="general.system.email" />
            <ToolTip body={<p><FormattedMessage id="general.email.status.tooltip" /></p>}
                   position={tooltipPositions.topRight} iconOnly invert />
          </th>
        </tr>
      </thead>
      <tbody>
        {report.map(row => {
          const customerLink = `#customer/${row.CustomerID}`;
          const analysisLink = `#customer/${row.CustomerID}/${row.PoolID}/analysis/report/latest/print`;

          return <tr key={row.PoolID}>
            <td><a href={customerLink}>{row.FullName}</a></td>
            <td>{row.HomePhone}</td>
            <td>{row.Email}</td>
            <td><a href={analysisLink}>{moment(row.PrevAnalysisDate).format(dateTimeFormats.numeralDate)}</a></td>
            <td>{moment(row.NextAnalysisDate).format(dateTimeFormats.numeralDate)}</td>
            <td>{formatEmails(row, formatMessage)}</td>
          </tr>;
        })}
      </tbody>
    </table>
    <div className='center-pagination'>
      <Pagination
        onPageChange={onPageChange}
        page={page}
        count={count}
        total={total} />
    </div>
  </div>;
};

export default PastDueReportResults;
